module.exports = __webpack_public_path__ + "static/media/Image-banner.2c9c081c.png";